Vue.component('contribution-chart', {
    props: ['assessment', 'tiny'],
    data() {
        return {
            //
        }
    },
    computed: {
        chartOptions() {
            var data = [];
            var colors = [];
            this.assessment.impact_driver_results.forEach(result => {
                data.push({
                    name: result.impact_driver.name,
                    value: result.total,
                });

                colors.push(result.impact_driver.map_color_max);
            });

            var chartOptions = {
              series: [
                {
                  color: colors,
                  name: "Approximate impact",
                  type: "pie",
                  radius: ['55%', '85%'],
                  data: data,
                  label: {
                      show: false
                  },
                },
              ],
              tooltip: {
                trigger: "item",
                formatter: function (params) {
                    return '<strong>'+ params.name + ':</strong> ≈ '+ Vue.filter('result')(params.value) + ' species•yr ('+ Vue.filter('percentage')(params.percent) +')';
                }
              },
              animation: false,
            }

            if (!this.tiny) {
                chartOptions.legend = {
                    orient: 'horizontal',
                    bottom: 10,
                }

                chartOptions.title = {
                    text: "Contribution per impact category",
                    left: "center",
                    top: 10,
                }

                chartOptions.series[0].label.show = true;
                chartOptions.series[0].radius = ['40%', '60%'];
            }


            return chartOptions;
        },
    },
    methods: {
        //
    },
    mounted() {
        //
    }
});